/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useContext, useState } from 'react';
import Cookie from 'universal-cookie';
import { useDispatch } from 'react-redux';
import { UsuariosContext } from 'contexts/UsuariosContext';
import { editUserMonYEstReg } from 'actions/users.actions';
import { Form, Input, Row, Col, Select, Checkbox, Button, message } from 'antd';
import './UserForm.scss';

export default function UserForm({ user, estados, cmonitoreos, rolName, callback }) {
  const dispatch = useDispatch();
  const { counter, setCounter } = useContext(UsuariosContext);
  const [disableBtnGuar, setDisableBtnGuar] = useState(false);
  const [form] = Form.useForm();
  const { Option } = Select;
  const optionsEdosFromUser = [];
  const optionsEncuestaFromUser = [];
  let optionOficinasC = false;
  let tokken = null;
  const coki = new Cookie();

  function getFieldsValuesFromUser() {
    for (let index = 0; index < user.listaEstadosUsuario.length; index += 1) {
      if (user.listaEstadosUsuario[index]?.id.idEstado !== 0) {
        if (!optionsEdosFromUser.includes(user.listaEstadosUsuario[index]?.id.idEstado)) {
          optionsEdosFromUser.push(user.listaEstadosUsuario[index]?.id.idEstado);
        }
      } else if (user.listaEstadosUsuario[index].id.idEstado === 0) {
        optionOficinasC = true;
      }
    }
    for (let j = 0; j < user.listaAsigMonitoreosUsuario.length; j += 1) {
      if (!optionsEncuestaFromUser.includes(user.listaAsigMonitoreosUsuario[j]?.id.idCMonitoreo)) {
        optionsEncuestaFromUser.push(user.listaAsigMonitoreosUsuario[j]?.id.idCMonitoreo);
      }
    }

    form.setFieldsValue({
      estRegional: optionsEdosFromUser,
      encuesta: optionsEncuestaFromUser,
      checkOficinas: optionOficinasC,
      grupo: rolName
    });
  }

  useEffect(() => {
    getFieldsValuesFromUser();
  }, [0]);

  const onFinishEncYEstR = async () => {
    setDisableBtnGuar(true);
    tokken = coki.get('JWT-TOKEN-SIMAC');
    const data = {
      dtoDataEditUser: {
        encuesta: form.getFieldValue('encuesta'),
        estRegional: form.getFieldValue('estRegional'),
        idUsuario: user.idUsuario,
        aliasUsuario: user.aliasUsuario
      },
      token: tokken
    };
    if (form.getFieldValue('checkOficinas')) {
      data.dtoDataEditUser.estRegional = [...data.dtoDataEditUser.estRegional, 0];
    }
    const { success, response } = await dispatch(editUserMonYEstReg(data));
    if (success && response?.data.code === 200) {
      message.success('Guardado exitoso');
      setDisableBtnGuar(false);
      setCounter(counter + 1);
      callback(false);
    } else {
      message.error('La acción solicitada no se pudo realizar, favor de comunicarse al CAU. ');
      setDisableBtnGuar(false);
    }
  };

  return (
    <div>
      <Form
        name="form-user"
        layout="vertical"
        form={form}
        className="user-form"
        onFinish={onFinishEncYEstR}>
        <Row className="row-form" gutter={28} style={{ paddingTop: '6px' }}>
          <Col span={8}>
            <Form.Item name="usuario" label="*Usuario:">
              <Input value={user.aliasUsuario} placeholder={user.aliasUsuario} disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="numEmpleado" label="*No. de empleado:">
              <Input
                value={user.numEmpleado}
                placeholder={user.numEmpleado ? user.numEmpleado : 'S/N'}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="puesto" label="*Puesto:">
              <Input value={user.puesto} placeholder={user.puesto} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row className="row-form" gutter={28}>
          <Col span={8}>
            <Form.Item name="nombre" label="*Nombre:">
              <Input value={user.nombre} placeholder={user.nombre} disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="primerApellido" label="*Primer apellido:">
              <Input value={user.apellidoPaterno} placeholder={user.apellidoPaterno} disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="segundoApellido" label="*Segundo apellido:">
              <Input value={user.apellidoMaterno} placeholder={user.apellidoMaterno} disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row className="row-form" gutter={28}>
          <Col span={8}>
            <Form.Item name="correo" label="*Correo electrónico:">
              <Input value={user.correo} placeholder={user.correo} disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="grupo" label="*Grupo:">
              <Input style={{ width: '78%' }} disabled />
            </Form.Item>
          </Col>
          <Col span={8} />
        </Row>
        <div>
          <Row>
            <Col span={24}>
              <h2 style={{ fontWeight: '500', color: '#494747' }}>
                Asignación de estructura regional y monitoreos
              </h2>
            </Col>
          </Row>
          <Row className="row-form" gutter={16}>
            <Col span={8}>
              <Form.Item
                name="estRegional"
                label="Estructura regional:"
                rules={[{ required: true, message: 'Dato requerido.' }]}>
                <Select
                  mode="multiple"
                  style={{ width: '94%' }}
                  allowClear
                  filterOption={(input, option) =>
                    option.key.toLowerCase().includes(input.toLowerCase())
                  }>
                  {estados
                    ? estados.map((data, _index) => (
                        <Option id={_index} key={data.nombreEstado} value={data.idEstado}>
                          {data.nombreEstado}
                        </Option>
                      ))
                    : null}
                </Select>
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                name="encuesta"
                label="Monitoreo:"
                rules={[{ required: true, message: 'Dato requerido.' }]}>
                <Select
                  mode="multiple"
                  allowClear
                  filterOption={(input, option) =>
                    option.key.toLowerCase().includes(input.toLowerCase())
                  }>
                  {cmonitoreos
                    ? cmonitoreos.map((data, _index) => (
                        <Option id={_index} key={data.monitoreo} value={data.idCMonitoreo}>
                          {data.monitoreo}
                        </Option>
                      ))
                    : null}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="checkOficinas" valuePropName="checked">
                <Checkbox>Oficinas centrales</Checkbox>
              </Form.Item>
            </Col>
          </Row>
          <Row className="row-btnguardar-form">
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: 150 }}
                  disabled={disableBtnGuar}
                  loading={disableBtnGuar}>
                  Guardar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
}
